import { useRef } from 'react';
import { Paperclip } from 'lucide-react';
import { fileService } from '../../services/PlatformService';

const MAX_FILES = 5;

const DocumentUploader = ({ onDocumentsChange, documents }) => {
  const fileInputRef = useRef(null);

  const handleFileSelect = async (e) => {
    const files = Array.from(e.target.files);
    const remainingSlots = MAX_FILES - documents.length;

    if (files.length > remainingSlots) {
      alert(`Você só pode enviar mais ${remainingSlots} arquivo(s).`);
      return;
    }

    for (const file of files) {
      try {
        const newFile = await fileService.uploadFile(file);
        onDocumentsChange(prev => [...prev, newFile.data]);
      } catch (error) {
        console.error('Erro ao fazer upload do arquivo:', error);
      }
    }

    // Limpa o input para permitir reenvio do mesmo arquivo se necessário
    e.target.value = '';
  };

  return (
    <div className="relative">
      <button
        onClick={() => {
          if (documents.length >= MAX_FILES) {
            alert(`Limite de ${MAX_FILES} arquivos atingido.`);
            return;
          }
          fileInputRef.current?.click();
        }}
        className="p-2 rounded-full hover:bg-gray-100 transition-colors"
        title="Anexar arquivo"
      >
        <Paperclip className="w-5 h-5 text-gray-500" />
      </button>

      <input
        ref={fileInputRef}
        type="file"
        multiple
        className="hidden"
        onChange={handleFileSelect}
        // aceitando qualquer arquivo, sem restrição
      />
    </div>
  );
};

export default DocumentUploader;
